// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_bf-3";
export var contentContainer = "_bf-0";
export var editorContainer = "_bf-1";
export var quillInputForm = "_bf-2";
export var zoneDivider = "_bf-4";